/**
 * @flow
 * @relayHash 313782bbe386f9d122ebb3ac2d523363
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddVendorItemPriceInput = {|
  vendorId: string,
  itemId: string,
  unitPrice: number,
  leadTimeDays: number,
  isPreferred?: ?boolean,
|};
export type AddVendorItemPriceMutationVariables = {|
  input: AddVendorItemPriceInput
|};
export type AddVendorItemPriceMutationResponse = {|
  +addVendorItemPrice: {|
    +vendorItemPriceEdge: {|
      +node: {|
        +id: string,
        +vendor: {|
          +id: string
        |},
        +item: {|
          +id: string,
          +name: string,
        |},
        +unitPrice: number,
        +leadTimeDays: number,
        +isPreferred: boolean,
        +createdAt: any,
      |}
    |}
  |}
|};
export type AddVendorItemPriceMutation = {|
  variables: AddVendorItemPriceMutationVariables,
  response: AddVendorItemPriceMutationResponse,
|};
*/


/*
mutation AddVendorItemPriceMutation(
  $input: AddVendorItemPriceInput!
) {
  addVendorItemPrice(input: $input) {
    vendorItemPriceEdge {
      node {
        id
        vendor {
          id
        }
        item {
          id
          name
        }
        unitPrice
        leadTimeDays
        isPreferred
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddVendorItemPriceInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addVendorItemPrice",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddVendorItemPricePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "vendorItemPriceEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "VendorItemPriceEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "VendorItemPrice",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor",
                "storageKey": null,
                "args": null,
                "concreteType": "Vendor",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "item",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "unitPrice",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "leadTimeDays",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isPreferred",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddVendorItemPriceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddVendorItemPriceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddVendorItemPriceMutation",
    "id": null,
    "text": "mutation AddVendorItemPriceMutation(\n  $input: AddVendorItemPriceInput!\n) {\n  addVendorItemPrice(input: $input) {\n    vendorItemPriceEdge {\n      node {\n        id\n        vendor {\n          id\n        }\n        item {\n          id\n          name\n        }\n        unitPrice\n        leadTimeDays\n        isPreferred\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '81dbc16ed563b0c9a5c49db3c0372d5e';
module.exports = node;
